import { decryptV2, encryptV2 } from "../Cryptography/CryptoV2";

export const getFileMime = async file => {
  const mimeType = await checkMimeType(file);

  return mimeType
}

const checkMimeType = (file) => {
  //List of known mimes
  var mimes = [
    {
      mime: 'image/jpeg',
      pattern: [0xFF, 0xD8, 0xFF],
      mask: [0xFF, 0xFF, 0xFF],
    },
    {
      mime: 'image/png',
      pattern: [0x89, 0x50, 0x4E, 0x47],
      mask: [0xFF, 0xFF, 0xFF, 0xFF],
    },
    {
      mime: 'video/avi',
      pattern: [0x52, 0x49, 0x46, 0x46],
      mask: [0xFF, 0xFF, 0xFF, 0xFF],
    },
    // {
    //   mime: 'video/mp4',
    //   pattern: [0x6D, 0x70, 0x34],
    //   mask: [0xFF, 0xFF, 0xFF],
    // }
    // you can expand this list @see https://mimesniff.spec.whatwg.org/#matching-an-image-type-pattern
  ];

  function check(bytes, mime) {
    for (var i = 0, l = mime.mask.length; i < l; ++i) {
      if ((bytes[i] & mime.mask[i]) - mime.pattern[i] !== 0) {
        return false;
      }
    }
    return true;
  }

  var blob = file.slice(0, 4); //read the first 4 bytes of the file


  var reader = new FileReader();
  const p1 = new Promise((resolve, reject) => {
    reader.onloadend = function (e) {
      if (e.target.readyState === FileReader.DONE) {
        var bytes = new Uint8Array(e.target.result);

        for (var i = 0, l = mimes.length; i < l; ++i) {
          if (check(bytes, mimes[i])) return resolve(mimes[i].mime);
        }

        return reject("unknown");
      }
    };
  })
  reader.readAsArrayBuffer(blob);

  return p1
}

export const replaceImgAccountName = (imgUrl) => {
  return imgUrl ?
    imgUrl
      ?.replace('epcfrmstoragenew', 'kmsmediasvcstorage')
      ?.replace('reimbursestorage', 'kmsmediasvcstorage')
      ?.replace('meconnectstorage', 'kmsmediasvcstorage')
    : ""
}


export const sleep = (time) => new Promise((resolve, reject) => setTimeout(resolve, time));

export const storeInEncLocalStorage = (key, value) => {
  const encValue = encryptV2(`${value}`);
  localStorage.setItem(key, encValue);
}

export const getFromEncLocalStorage = (key) => {
  const value = localStorage.getItem(key);
  if (value === null || value === "") return value;
  const decValue = decryptV2(value);
  return decValue;
}